import React from "react";
import Scorebug from "../Scorebug/Scorebug";
import ClubV2 from "../ClubV2";
import { StyledEmptyScorebug, StyledMatchTile } from "./StyledMatchTile";

function MatchTile({
  status,
  homeClubData,
  awayClubData,
  isHomeWinner = false,
  isAwayWinner = false,
  hasFullName = false,
  hasShortName = false,
  hasAbbreviation = false,
  homeScore,
  awayScore,
  homeClubRank = null,
  awayClubRank = null,
  hideScorebug = false,
  abbreviateStatus = false,
}) {
  return (
    <StyledMatchTile className={`mls-c-match-tile --${status?.abbreviation}`}>
      <ClubV2
        className={!isHomeWinner && isAwayWinner ? "--home-loser" : ""}
        clubData={homeClubData}
        isHome
        hasAbbreviation={hasAbbreviation}
        hasFullName={hasFullName}
        hasShortName={hasShortName}
        rank={homeClubRank}
      />
      {hideScorebug ? (
        <StyledEmptyScorebug />
      ) : (
        <Scorebug
          homeScore={homeScore}
          awayScore={awayScore}
          abbreviateStatus={abbreviateStatus}
        />
      )}
      <ClubV2
        className={!isAwayWinner && isHomeWinner ? "--away-loser" : ""}
        clubData={awayClubData}
        isHome={false}
        hasAbbreviation={hasAbbreviation}
        hasFullName={hasFullName}
        hasShortName={hasShortName}
        rank={awayClubRank}
      />
    </StyledMatchTile>
  );
}

// eslint-disable-next-line no-const-assign,no-func-assign
MatchTile = React.memo(MatchTile);

export default MatchTile;
